var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 80,
    viewBox: "0 0 1360 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#00A3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_568_305",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1360,
    height: 80
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1360,
    height: 80,
    rx: 12,
    fill: "#00A3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_568_305)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1344,
    cy: 20,
    r: 30,
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1238.22 52.0106C1241.61 28.2594 1262.04 10 1286.73 10C1302.81 10 1317.09 17.7519 1326.02 29.7239C1329.88 28.4864 1334 27.8182 1338.27 27.8182C1360.41 27.8182 1378.36 45.7675 1378.36 67.9091C1378.36 90.0507 1360.41 108 1338.27 108H1286.73H1239H1235.18V107.742C1221.52 105.88 1211 94.1688 1211 80C1211 64.7962 1223.12 52.4227 1238.22 52.0106Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudy);
export default __webpack_public_path__ + "static/media/Cloudy.afb98af2bd43d3a2a330e655695bd2c9.svg";
export { ForwardRef as ReactComponent };